import { Component, OnInit } from '@angular/core';
import Endereco from '../../../../../models/perfil/endereco.model';
import { LoadingService } from '../../../../../util/loader.service';
import { environment } from '../../../../../../environments/environment';
import { MapMouseEvent, Map, LngLat } from 'mapbox-gl';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LojaService } from './loja.service';
import { Perfil } from '../../../../../models/perfil/perfil.model';


@Component({
  selector: 'app-loja',
  templateUrl: './loja.component.html',
  styleUrls: ['./loja.component.scss']
})
export class LojaComponent implements OnInit {
  valForm: FormGroup;
  map: Map;
  _zoom: number;
  index: number;
  set zoom(z: number) {
    this._zoom = z;
    if (this.index === 0) {
      // this.zoomChange.emit(this._zoom);
    }
  }
  //refs
  _mapRef: Map;

  record: Perfil;
  maskCep;
  centroMapa: LngLat;

  _center: LngLat;

  constructor(fb: FormBuilder,
    public loader: LoadingService,
    public service: LojaService,
  ) {
    this.valForm = fb.group({
      'receitaFederalEmpresaEstado': [null, [Validators.required]],
      'receitaFederalEmpresaCidade': [null, [Validators.required]],
      'receitaFederalEmpresaBairro': [null, [Validators.required]],
      'receitaFederalEmpresaLogradouro': [null, [Validators.required]],
      'receitaFederalEmpresaCep': [null, [Validators.required]],
      receitaFederalEmpresaNumero: [null, [Validators.required]],

    });

    this.record = new Perfil();
    this.obterInformacao();
    this.maskCep = [/[1-9]/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  }

  obterInformacao() {
    this.service.detalhar().subscribe(itens => {
      this.record = itens;

      //this._center = new LngLat(itens.latitude, itens.longitude);
      debugger;
      this.centroMapa = new LngLat(itens.longitude, itens.latitude);
      debugger;
    });
  }
  onMapLoad(map) {
    map.resize();
    console.log("Initializing map, _center: ", this._center);
    console.log("map: ", map);
    this._mapRef = map;
    this.map = map;
    console.log("Loading map data");
    this._center = map.getCenter();
    console.log('this._center from map: ', this._center);
    this._mapRef.resize();
    this.map.resize();
    debugger;
    setTimeout(function () {
      if (this.map != null) {
        this.map.resize();
        this._center = this.centroMapa;
      }
    }, 1000);
    setTimeout(() => {
      this._center = this.centroMapa;
    }, 2000);

  }
  ngOnInit() {
    this.zoom = 11;
    this._center = new LngLat(-52.2520849, -7.2006733);
    //this._center = new LngLat(-121.31209, 37.449904);
  }

}
